import type { Options } from '@splidejs/splide';

/** Parity with former Slick standard carousel (arrows off at 480px). */
export const standardCarouselSplideOptions: Options = {
	type: 'slide',
	rewind: true,
	perPage: 1,
	perMove: 1,
	pagination: true,
	arrows: true,
	speed: 300,
	// See the quote slider: Splide's region needs a name, and the
	// roledescription already says "carousel".
	label: 'Slides',
	breakpoints: {
		480: {
			arrows: false,
		},
	},
};
